module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "Chap-Title-ct-BMH"
  }, [_c('span', {
    attrs: {
      "aria-label": "ix",
      "id": "pg_ix",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_aut",
      "id": "aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUTHOR’S NOTE ON ENDNOTES, PREFATORY MATERIAL, AND NAMES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("The 3,350 endnotes for "), _c('i', [_vm._v("Proof of Conspiracy")]), _vm._v(", comprising 4,300 individual citations, run over 375 pages. For this reason—and to ensure that this key element of the text is both link-enabled and searchable—it has been published for free online rather than in the pages of this book. You can find it at "), _c('a', {
    attrs: {
      "href": "https://read.macmillan.com/proofofconspiracynotes/",
      "target": "_blank"
    }
  }, [_vm._v("www.read.macmillan.com/proofofconspiracynotes")]), _vm._v(". The pages at this link are numbered in a manner consistent with the numbering they would have received had they appeared in the print edition of "), _c('i', [_vm._v("Proof of Conspiracy")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("As this book is the sequel to "), _c('i', [_vm._v("Proof of Collusion")]), _vm._v(" (Simon & Schuster, 2018), the contents of that book should be regarded as prefatory material to the contents of this one. Except where clearly necessary, "), _c('i', [_vm._v("Proof of Conspiracy")]), _vm._v(" does not reiterate the information about the Trump-Russia investigation contained in "), _c('i', [_vm._v("Proof of Collusion")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('i', [_vm._v("Proof of Conspiracy")]), _vm._v(" discusses the activities of certain individuals with Arabic names. These names, and the others that appear throughout the text, are listed alphabetically in an index at the back of the book. Note that compound Arabic surnames that include a definite article as their prefix are maintained as such in this text. Thus, for instance, “Yousef al-Otaiba” is “al-Otaiba” throughout the work, rather than “Otaiba,” despite conventions permitting either transliteration.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73a0de68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/authorsnote.vue
// module id = 72
// module chunks = 0